import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';

/**
 * Retrieves all MFA devices registered for the current user.
 *
 * This function fetches the list of multi-factor authentication devices
 * associated with the user's account, such as TOTP authenticators.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to an array of the user's registered MFA devices.
 */
export const getMfaDevices = async (client = getDefaultClient()) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const { devices } = await apiClient.getUserMfaDevices({
    environmentId: core.environmentId,
  });

  return devices;
};
